import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

interface YesNoButtons {
  yes: { title: string; disabled: boolean };
  no: { title: string; disabled: boolean };
}

@Component({
  selector: 'app-modal-close',
  templateUrl: './modal-close.component.html',
  styleUrls: ['./modal-close.component.scss']
})
export class ModalCloseComponent implements OnInit {

  constructor(@Optional() @Inject( MAT_DIALOG_DATA ) public data: { headerTemplate: string, buttons?: YesNoButtons },
              public dialogRef: MatDialogRef<ModalCloseComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal-close/modal-close.component.ts